import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ReactConfig } from './configApi';
import { createBrowserHistory } from 'history';

export const reactPlugin = new ReactPlugin();

export const GetApplicationInsights = (reactConfig: ReactConfig) => {
  var appInsightsInit = new ApplicationInsights({
    config: {
      connectionString: reactConfig!.applicationInsightsConnectionString,
      extensions: [reactPlugin!],
      extensionConfig: {
        [reactPlugin!.identifier]: {
          history: createBrowserHistory(),
        },
      },
      disableDataLossAnalysis: false,
      enableAutoRouteTracking: true,
      enableAjaxErrorStatusText: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    },
  });
  appInsightsInit.loadAppInsights();
  return appInsightsInit;
};
